import InfiniteScroll from 'react-infinite-scroller';

import CatalogItem from '@components/bandSearch/CatalogItem';

import css from '@styles/bandSearch';

const loadingIcon = '/images/loading-diamond.gif';

function Loading () {
  return (
    <div className={css.loading}>
      <div>
        <img src={loadingIcon} alt="Loading icon" />
      </div>
      <p>Loading bands...</p>
    </div>
  );
}

function SearchResults ({
  items,
  allowGettingMoreResults,
  onInfiniteLoad,
  isLoading
}) {
  return (
    <InfiniteScroll
      loadMore={onInfiniteLoad}
      hasMore={allowGettingMoreResults}
      className={css.container}
      threshold={500}
      initialLoad={false}>
      {items.map((item) => <CatalogItem key={item.vendor_sku} item={item} />)}
      {isLoading && <Loading key="loading" />}
    </InfiniteScroll>
  );
}

export default SearchResults;
